import * as React from "react";
import { browserHistory } from "react-router";
import PropTypes from "prop-types";
import translate from "react-i18next/dist/commonjs/translate";

class LogsSourceWidgetTableRowShowMore extends React.Component {
  constructor(props) {
    super(props);

    this.gotoLogSources = this.gotoLogSources.bind(this);
  }

  gotoLogSources() {
    browserHistory.push(`${global.applicationPath}/log-sources`);
  }

  render() {
    const { t } = this.props;
    return (
      <tr onClick={this.gotoLogSources}>
        <td>
          <strong>{t("logSourceWidgetShowMore")}</strong>
        </td>
        <td />
      </tr>
    );
  }
}

LogsSourceWidgetTableRowShowMore.propTypes = {
  t: PropTypes.func.isRequired
};

export default translate("translations")(LogsSourceWidgetTableRowShowMore);



// WEBPACK FOOTER //
// ./src/dashboard/widgets/LogsSourceWidgetTableRowShowMore.js